import * as React from 'react';
import { Adresse, Event, TypeEvent, Course } from '../../../types/ServerRequests';
import { TypeEventService } from '../../../services/TypeEventService';
import * as ReqType from '../../../types/ServerRequests';
import { EventService } from '../../../services/EventService';
import { AdresseForm } from '../../genericComponents/AdresseForm/AdresseForm';
import { CoursService } from '../../../services/CoursService';
import { DatetimeForm } from '../../genericComponents/Date/DatetimeForm';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    /**
     * event: l'event
     */
    event: Event;

    /**
     * permet de changer un profil
     * @param {Event} e
     */
    changeEvent: (e: Event) => void;

    /**
     * tableautypeevent: le typeEvent
     */
    redirect: () => void;
}

/**
 * interface State (l'état interne de la classe CreateEvent)
 */
interface State {
    /**
     * tableautypeevent: le typeEvent
     */
    tableautypeevent: TypeEvent[];
    /**
     * tableaucour: le Cours
     */
    tableaucour: Course[];
}

/**
 * Ce composant permet la creation d'un Evénement a fin de l'ajouter dans la base de donner.
 * Il prend en paramétre un tableau de typeEvénement et un tableau de Cour.
 * Nous utilisons les servicesType event Services et CoursService pour compléter ces tableau.
 */
export class CreateEvent extends React.Component {
    /** le state: l'etat interne */
    state: State;
    /** le props: l'etat externe */
    props: Props;

    /**
     * construit le formulaire de creation d'un event CreateEvent
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            tableautypeevent: [],
            tableaucour: [],
        };
        this.getTypeEvents();
        this.getcours();
    }

    /**
     * modification du state type event
     * @param {React.ChangeEvent<HTMLSelectElement>} e
     */
    handleChangeTypeEvent = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var monEvent = EventService.getInstance().duplicateEvent(this.props.event);
        monEvent.type_event = this.state.tableautypeevent[e.target.value];
        this.props.changeEvent(monEvent);
    }

    /**
     * modification du state cour
     * @param {React.ChangeEvent<HTMLSelectElement>} e
     */
    handleChangeCour = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var monEvent = EventService.getInstance().duplicateEvent(this.props.event);
        monEvent.cours = this.state.tableaucour[e.target.value];
        this.props.changeEvent(monEvent);
    }

    /**
     * modification du state description
     * @param {React.ChangeEvent<HTMLSelectElement>} e
     */
    handledescription = (e: React.ChangeEvent<HTMLInputElement>) => {
        var monEvent = EventService.getInstance().duplicateEvent(this.props.event);
        monEvent.description = e.target.value;
        this.props.changeEvent(monEvent);
    }

    /**
     * modification du state Budget
     * @param {React.ChangeEvent<HTMLSelectElement>} e
     */
    handleBudget = (e: React.ChangeEvent<HTMLInputElement>) => {
        var monEvent = EventService.getInstance().duplicateEvent(this.props.event);
        monEvent.budget = e.target.value;
        this.props.changeEvent(monEvent);
    }

    /**
     * le rendu de la classe de création d'évènement
     * @returns {JSX.element)
     */
    render() {
        var cours = this.state.tableaucour.map(
            (index: ReqType.Course, nombre: number) => {
                if (index.status === 1) {
                    return (
                        <option
                            key={nombre}
                            id={nombre.toString()}
                            value={index.id}
                        >
                            {index.details}
                        </option>
                    );
                } else {
                    return undefined;
                }
            }
        );

        var typeevent = this.state.tableautypeevent.map((index: TypeEvent, nombre: number) =>
            (
                <option
                    key={nombre}
                    id={nombre.toString()}
                    value={index.id}
                >
                    {index.nom_type}
                </option>
            )
        );

        return (
            <div className="form-group">
                <div>
                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Intitulé :
                        </label>
                        <input
                            type="text"
                            className="form-control-lg col-sm-6"
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var monEvent = EventService.getInstance().duplicateEvent(this.props.event);
                                    monEvent.intitule = e.target.value;
                                    this.props.changeEvent(monEvent);
                                }
                            }
                            value={this.props.event.intitule}
                        />
                    </div>

                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Type d'événement :
                        </label>
                        <select
                            onChange={this.handleChangeTypeEvent}
                            value={this.props.event.type_event.id}
                            className="form-control-lg col-sm-6"
                        >
                            <option value="-1" disabled={true}>
                                Selectionnez un type d'événement
                          </option>
                            {typeevent}
                        </select>
                    </div>

                    <div className="row form-group">
                        <label
                            style={{fontSize: '20px', width: '5.1cm', marginTop: '13px'}}
                            className="text-right col-form-input"
                        >
                            Adresse :
                        </label>
                        <div className="form-control-lg col-sm-6">
                            <AdresseForm
                                disabled={false}
                                adresse={this.props.event.adresse}
                                setAdresse={this.setadresse}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Cours :
                        </label>
                        <select
                            onChange={this.handleChangeCour}
                            value={this.props.event.cours === null ? '-1' : this.props.event.cours.id}
                            className="form-control-lg"
                        >
                            <option value="-1" disabled={true}>
                                Selectionnez un cour
                          </option>
                            {cours}
                        </select>
                    </div>
                    <div className="row col-12 form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm'}}
                            className="text-right col-form-input"
                        >
                            Date de début :
                        </label>
                        <DatetimeForm
                            date={this.props.event.date_heure_debut}
                            disabled={false}
                            setDate={
                                (d: Date) => {
                                    var newEvent = EventService.getInstance().duplicateEvent(this.props.event);
                                    newEvent.date_heure_debut = d;
                                    this.props.changeEvent(newEvent);
                                }
                            }
                            hour={true}
                        />
                    </div>
                    <div className="row col-12 form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm'}}
                            className="text-right col-form-input"
                        >
                            Date de fin :
                        </label>
                        <DatetimeForm
                            date={this.props.event.date_heure_fin}
                            disabled={false}
                            setDate={
                                (d: Date) => {
                                    var newEvent = EventService.getInstance().duplicateEvent(this.props.event);
                                    newEvent.date_heure_fin = d;
                                    this.props.changeEvent(newEvent);
                                }
                            }
                            hour={true}
                        />
                    </div>
                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginRight: '16px'}}
                            className="text-right col-form-input"
                        >
                            Description :
                        </label>
                        <input
                            type="text"
                            onChange={this.handledescription}
                            className="form-control-lg"
                        />
                    </div>
                    <div className="form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginRight: '16px'}}
                            className="text-right col-form-input"
                        >
                            Budget :
                        </label>
                        <input
                            type="number"
                            className="form-control-lg"
                            step="1.0"
                            min="0"
                            onChange={this.handleBudget}
                        />
                    </div>
                    <LoaderButton
                        className="btn"
                        style={{marginLeft: '1cm', width: '3cm'}}
                        onClick={
                            () => {
                                return EventService.getInstance().createEvent(this.props.event).then(
                                    () => {
                                        this.props.redirect();
                                    }
                                ).catch(
                                    (e) => { alert(JSON.stringify(e)); }
                                );
                            }
                        }
                    >
                        Valider
                    </LoaderButton>
                </div>
            </div>
        );
    }

    /**
     * modification de l'adresse
     * @param {Adresse} e
     */
    private setadresse = (e: Adresse) => {
        var monEvent: ReqType.Event = EventService.getInstance().duplicateEvent(this.props.event);
        monEvent.adresse = e;
        this.props.changeEvent(monEvent);
    }

    /**
     * retourn le Type Events
     */
    private getTypeEvents() {
        TypeEventService.getInstance().getTypes().then(
            (ret: TypeEvent[]) => {
                var arr: ReqType.TypeEvent[] = [];
                ret.map(
                    (e: ReqType.TypeEvent) => {
                        arr[e.id] = e;
                    }
                );
                this.setState({ tableautypeevent: arr });
            }
        ).catch(
            (e) => { alert(JSON.stringify(e)); }
        );
    }

    /**
     * retourn le cours
     */
    private getcours() {
        CoursService.getInstance().getCoursList().then(
            (ret: ReqType.Course[]) => {
                var arr: ReqType.Course[] = [];
                ret.map(
                    (e: ReqType.Course) => {
                        arr[e.id] = e;
                    }
                );
                this.setState({ tableaucour: arr });
            }
        ).catch(

            (e) => { JSON.stringify(e); }
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/CreateEvent.tsx